module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/game-icon-5ec04ba6ddb7f63f8b70ff239e5fff2a.png";